import React from "react";
import { Alert, Icon, Button } from "antd";
import get from "lodash/get";

import {DatafaxReprocessing, DatafaxCheckStatus, DatafaxPull} from "../../api/requests";

import classes from "./PatientProfileForm.css";
import { withNamespaces } from "react-i18next";

const statuses = {
  'completed': 'success',
  'declined': 'error',
  'error': 'error',
  'pending': 'warning',
  'idle': 'info',
};

class PatientDatafaxProcessing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSent: false,
      isLoading: false,
      requestResult: null,
      isSentStatus: false,
      isSentPull: false,
      isLoadingStatus: false,
      isLoadingPull: false,
      requestResultStatus: null,
      requestResultPull: null,
    };
  }

  handleSubmit = async () => {
    this.setState({ isLoading: true });
    try {
      const data = await DatafaxReprocessing(this.props.subjectID);

      this.setState({
        isSent: true,
        requestResult: {
          type: data.data.state,
          message: data.data.message,
        },
      });
    } catch (e) {
      this.setState({
        requestResult: {
          type: "error",
          message: "Error",
        },
      });
    }

    this.setState({ isLoading: false });
  };
  handleSubmitPull = async () => {
    this.setState({ isLoadingPull: true });
    try {
      const data = await DatafaxPull(this.props.subjectID);

      this.setState({
        isSentPull: true,
        requestResultPull: {
          type: data.data.state,
          message: data.data.message,
        },
      });
    } catch (e) {
      this.setState({
        requestResultPull: {
          type: "error",
          message: this.props.i18n.t("Error"),
        },
      });
    }

    this.setState({ isLoadingPull: false });
  };

  handleSubmitCheckStatus = async () => {
    this.setState({ isLoadingStatus: true });
    try {
      const data = await DatafaxCheckStatus(this.props.subjectID);

      this.setState({
        isSentStatus: true,
        requestResultStatus: {
          type: data.data.state,
          message: data.data.message,
        },
      });
    } catch (e) {
      this.setState({
        requestResultStatus: {
          type: "error",
          message: this.props.i18n.t("Error"),
        },
      });
    }

    this.setState({ isLoadingStatus: false });
  };

  render() {
    const {} = this.props;

    const {
      isLoading,
      isSent,
      requestResult,
      isLoadingStatus,
      isLoadingPull,
      isSentStatus,
      isSentPull,
      requestResultStatus,
      requestResultPull,
    } = this.state;

    return (
      <div className={classes.patientProfileForm}>

        <div>
          <Button
            disabled={isSentStatus}
            type="primary"
            size="large"
            htmlType="button"
            onClick={this.handleSubmitCheckStatus}
            className={classes.submitButton}
          >
            {this.props.i18n.t('NamespacePatientAPIControls:DFDiscover Check Status')}
            {isLoadingStatus && <Icon type="loading" />}
          </Button>
          <br/><br/>
          {requestResultStatus && requestResultStatus.type &&
          <Alert message={requestResultStatus.message} type={statuses[requestResultStatus.type]} style={{ width: '300px'}}/>
          }
        </div>

        <br/>
        <div>
          <Button
            disabled={isSent}
            type="primary"
            size="large"
            htmlType="button"
            onClick={this.handleSubmit}
            className={classes.submitButton}
          >
            {this.props.i18n.t('NamespacePatientAPIControls:DFDiscover Push Subject')}
            {isLoading && <Icon type="loading" />}
          </Button>
          <br/><br/>
          {requestResult && requestResult.type &&
          <Alert message={requestResult.message} type={statuses[requestResult.type]} style={{ width: '300px'}}/>
          }
        </div>

        <br/>


        <div>
          <Button
            disabled={isSentPull}
            type="primary"
            size="large"
            htmlType="button"
            onClick={this.handleSubmitPull}
            className={classes.submitButton}
          >
            {this.props.i18n.t('NamespacePatientAPIControls:DFDiscover Pull subject')}
            {isLoadingPull && <Icon type="loading" />}
          </Button>
          <br/><br/>
          {requestResultPull && requestResultPull.type &&
          <Alert message={requestResultPull.message} type={statuses[requestResultPull.type]} style={{ width: '300px'}}/>
          }
        </div>
      </div>
    );
  }
}

export default withNamespaces()(PatientDatafaxProcessing);



// WEBPACK FOOTER //
// ./src/components/PatientProfileForm/PatientDatafaxProcessing.js